export const ACT_ROUTE = 'Act';
export const RECEIPT_ROUTE = 'Receipt';
